import { gql } from "@apollo/client";

const CAMPAIGN_RECIPE_FIELDS = gql`
  fragment CampaignRecipeFields on CampaignRecipe {
    id
    campaignId
    userId
    siteId
    parentId
    groupId
    createdAt
    updatedAt
    campaignType
    siteType
    name
    tags
    content
    data
    schedule
    target
    display
    meta
    language
    device
    preview
    isActive
    isDeleted
    seq
    children {
      preview
    }
    parent {
      data
    }
  }
`;

export const UPSERT_CAMPAIGN_RECIPE = gql`
  ${CAMPAIGN_RECIPE_FIELDS}
  mutation UpsertCampaignRecipe($campaignRecipe: CampaignRecipeInput!) {
    upsertCampaignRecipe(campaignRecipe: $campaignRecipe) {
      ...CampaignRecipeFields
    }
  }
`;

export const GET_CAMPAIGN_RECIPE = gql`
  ${CAMPAIGN_RECIPE_FIELDS}
  query GetCampaignRecipe($id: ID!) {
    getCampaignRecipe(id: $id) {
      ...CampaignRecipeFields
    }
  }
`;

export const GET_CAMPAIGN_RECIPE_BY_CAMPAIGN_ID = gql`
  ${CAMPAIGN_RECIPE_FIELDS}
  query GetCampaignRecipeByCampaignId($campaignId: ID!) {
    getCampaignRecipeByCampaignId(campaignId: $campaignId) {
      ...CampaignRecipeFields
    }
  }
`;

export const GET_CAMPAIGN_RECIPES_BY_CAMPAIGN_TYPE = gql`
  ${CAMPAIGN_RECIPE_FIELDS}
  query GetCampaignRecipesByCampaignType(
    $campaignType: CampaignType!
    $hasParent: Boolean!
    $isActive: Boolean
  ) {
    getCampaignRecipesByCampaignType(
      campaignType: $campaignType
      hasParent: $hasParent
      isActive: $isActive
    ) {
      ...CampaignRecipeFields
    }
  }
`;
